"use client";

import { c as _c } from "react/compiler-runtime";
import type { DropInteractionParams } from "@/components/waves/drops/Drop";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import type { INotificationIdentityMentioned } from "@/types/feed.types";
import NotificationWithDrop from "../subcomponents/NotificationWithDrop";
export default function NotificationIdentityMentioned(t0) {
  const $ = _c(6);
  const {
    notification,
    activeDrop,
    onReply,
    onDropContentClick
  } = t0;
  let t1;
  if ($[0] !== activeDrop || $[1] !== notification.created_at || $[2] !== notification.related_drops[0] || $[3] !== onDropContentClick || $[4] !== onReply) {
    t1 = <NotificationWithDrop drop={notification.related_drops[0]} actionText="mentioned you" createdAt={notification.created_at} activeDrop={activeDrop} onReply={onReply} onDropContentClick={onDropContentClick} />;
    $[0] = activeDrop;
    $[1] = notification.created_at;
    $[2] = notification.related_drops[0];
    $[3] = onDropContentClick;
    $[4] = onReply;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}